module.exports = __webpack_public_path__ + "static/fonts/ziemann-icons.af543b28.woff2";